import React from 'react';
import Header from './components/Header';
import Navigation from './components/Navigation';

const App = ({ checkUrl, downloadUrl }) => {
    return (
        <>
            <Navigation />
            <Header checkUrl={checkUrl} downloadUrl={downloadUrl} />
        </>
)}

export default App;
